<template>
  <ResultTemplate>
    <TheListTitle :listTitle="tagResult.name || articleTitle" prefix="tag" />
    <AccesskeyLink
      id="mainContent"
      class="accesskey-c"
      accesskey="C"
      title=":::主要內容顯示區"
    />
    <ArticleRelatedFields>
      <!-- 藝品導覽 -->
      <ArticleRelatedField
        displayType="card"
        linkPath="artwork"
        :titleImage="{
          src: 'artwork-title',
          alt: tagResult.name,
          mode: 'thick',
        }"
        :fieldData="tagResult.artworks"
      />
      <!-- 廟宇導覽 -->
      <ArticleRelatedField
        displayType="card"
        linkPath="temple"
        :titleImage="{
          src: 'home-title-temple',
          alt: '廟宇導覽',
          mode: 'thick',
        }"
        :fieldData="tagResult.temples"
      />
      <!-- 旅遊導覽 -->
      <ArticleRelatedField
        displayType="card"
        linkPath="theme"
        :titleImage="{ src: 'theme-title', alt: '旅遊導覽', mode: 'thick' }"
        :fieldData="tagResult.themes"
      />
      <!-- 圖鑑集 -->
      <ArticleRelatedField
        displayType="album"
        linkPath="album"
        :titleImage="{ src: 'more-albums', alt: '圖鑑集', mode: 'medium' }"
        :fieldData="tagResult.albums"
      />
      <!-- 標籤 -->
    </ArticleRelatedFields>
    <TheListPagination
      :pages="{
        current_page: tagPages.currentPage,
        last_page: tagPages.lastPage,
      }"
      category=""
      @update:getUpdatedArticles="changePage"
    />
  </ResultTemplate>
</template>

<script>
// import { lazyloading } from '@/utils/lazyloading';
import { getArticleString } from "@/config/articleString";
import TheListTitle from "@/components/list/TheListTitle";
import ResultTemplate from "@/components/ResultTemplate";
import ArticleRelatedFields from "@/components/article/ArticleRelatedFields";
import ArticleRelatedField from "@/components/article/ArticleRelatedField";
import TheListPagination from "@/components/list/TheListPagination";
import AccesskeyLink from "@/components/a11y/AccesskeyLink.vue";

// import TheTags from '@/components/TheTags';

import { mapGetters } from "vuex";

export default {
  name: "TagResults",
  metaInfo() {
    return {
      title: this.tagResult.name
        ? `${this.tagResult.name} - 標籤檢索`
        : "標籤檢索",
      meta: [
        {
          vmid: "og:url",
          property: "og:url",
          content: this.productionWholeReference,
        },
        {
          vmid: "og:title",
          property: "og:title",
          content: "臺南宗教藝術-您所查詢的相關標籤",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: "您所查詢的相關標籤資訊在這裡喔。",
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["tagResult", "productionHostname", "tagPages"]),
    productionWholeReference() {
      return `${this.productionHostname}${window.location.pathname}${window.location.search}${window.location.hash}`;
    },
    articleTitle() {
      return getArticleString("tag", "headline");
    },
  },
  async mounted() {
    await this.getTagResult();
    // await lazyloading();
  },
  methods: {
    async getTagResult(page = 1) {
      try {
        await this.$store.dispatch("getTagResult", {
          tagId: this.$route.params.tagId,
          params: {
            page,
            limit: this.tagPages.perPage,
          },
        });
      } catch (e) {
        console.error(e);
      }
    },
    changePage({ page }) {
      this.getTagResult(page);
    },
  },
  components: {
    ResultTemplate,
    ArticleRelatedFields,
    ArticleRelatedField,
    TheListTitle,
    TheListPagination,
    AccesskeyLink,
    // TheTags,
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadein {
  from {
    color: transparent;
    opacity: 0;
  }
  to {
    color: $color-light-title;
    opacity: 1;
  }
}

.transition {
  font-family: $text-font-family;
  color: transparent;
  font-size: 1.75rem;
  animation: 3s linear 3s 1 fadein;
}
</style>
